import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "13 17 18 12 13 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "6 17 11 12 6 7", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ChevronsRight";
const ChevronsRight = memo(themed(Icon));
export {
  ChevronsRight
};
//# sourceMappingURL=chevrons-right.js.map
